import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	editorEnabled: {
		id: 'browser-status-indicator.user.offline.editor.enabled',
		description:
			"Message shown when the user's internet is offline and the editing capabilities have not been disabled.",
		defaultMessage:
			'We’ve lost our connection to you. Your changes will be saved when we reconnect. Trying to reconnect',
	},
	editorEnabledOfflineMode: {
		id: 'browser-status-indicator.user.offline.editor.offline-mode.enabled',
		description: "Message shown when the user's internet went offline but is back online now",
		defaultMessage: 'You’re back online. You can now use all editing features.',
	},
	editorDisabled: {
		id: 'browser-status-indicator.user.offline.editor.disabled',
		description:
			"Message shown when the user's internet is offline and the editing capabilities have been disabled.",
		defaultMessage:
			'We’ve lost our connection to you, so we’ve disabled editing to prevent any issues. You’ll be able to edit once we reconnect. Trying to reconnect',
	},
	editorDisabledOfflineMode: {
		id: 'browser-status-indicator.user.offline.editor.offline-mode.disabled',
		description:
			"Message shown when the user's internet is offline and the editing capabilities have been limited.",
		defaultMessage:
			'Looks like you’re offline. Any changes you make will be automatically saved. Some features will be unavailable.',
	},
	backOnline: {
		id: 'browser-status-indicator.back.online',
		description: "Message shown when the user's internet went offline but is back online now",
		defaultMessage: 'Editing restored',
	},
	editorDisabledDueToPermissionChange: {
		id: 'browser-status-indicator.permission.change.offline',
		description:
			'Message to inform user that editing is having problems because of their recent permission change',
		defaultMessage:
			'The access update you made is taking longer than expected to save, so we’ve disabled editing to prevent any issues. You’ll be able to edit once the changes finish saving. Saving',
	},
	collabEditConnectionTimeout: {
		id: 'browser-status-indicator.collab.edit.timeout',
		description:
			'Message to inform user the collab edit connection is taking longer than X seconds',
		defaultMessage:
			'We’ve lost our connection to you, so editing is paused to prevent any issues. You can edit again once we reconnect, but you may want to copy and save this work now. Trying to reconnect',
	},
	editorSyncFailedDueToConflicts: {
		id: 'browser-status-indicator.collab.edit.conflicts.non-final',
		description:
			'Message to inform user that the editor sync failed due to conflicts, when coming back online',
		defaultMessage:
			'{conflictIcon} We found <conflictLink>{conflictCount, plural, =1 {# conflict} other {# conflicts}}</conflictLink> while syncing your offline edits. Review them below or <saveCopy>save a copy</saveCopy> of your offline edits.',
	},
});
